/// <amd-module name="typeahead/features/IncludeHotelsNearRegion" />
/// <amd-dependency path="jquery" name="$"/>
/// <amd-dependency path="typeahead/core/loc" name="loc"/>

/// <reference path="../../typings/typeahead/loc.d.ts" />

"use strict";

import {ClientHandlerRegistry, IHsrpSubmitData} from "typeahead/client/ClientHandlerRegistry";
import {IInputElementConfig} from "typeahead/core/ExpediaSuggestServiceRequestGenerator";
import {Experiment} from "typeahead/core/Experiment";
import {IExperimentalFeature} from "typeahead/core/IExperimentalFeature";
import {ElementFocusedMessage} from "typeahead/core/message/ElementFocusedMessage";
import {InputValueEditedMessage} from "typeahead/core/message/InputValueEditedMessage";
import {SuggestionSelectedMessage} from "typeahead/core/message/SuggestionSelectedMessage";
import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import {IDropdownContentHandler} from "typeahead/core/presentation/IDropdownContentHandler";
import * as StripingConfiguration from "typeahead/core/StripingConfiguration";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import {IExtraSearchParam} from "typeahead/core/Suggestion";
import {TypeaheadUtils} from "typeahead/core/TypeaheadUtils";
import {Optional} from "typeahead/core/util/Optional";
import {addFeatureFlag} from "typeahead/dataprovider/suggestservice/SuggestServiceQueryParamsUtils";

const configuration: IStripingConfiguration[] =
    [
        {
            clients: ["Hotels.Search"],
            experiment: {
                id: 26252,
                name: "ESS_One_Search_Typeahead_in_HSRP_that_supports_both_regions_and_hotels",
                value: 1,
            },
        },
    ];

const featureFlag = "onesearchta";
const hotelNameHotelBits = 128; // (hotelNameHotelBits >>> 0).toString(2) = "10000000"

export class IncludeHotelsNearRegion implements IRequestUrlParamModifier, IDropdownContentHandler,
    IExperimentalFeature, IPageLoadHandler {

    private static readonly applicableClientIds: string[] = ["Hotels.Search"];
    private static readonly applicableTextInputElementIds: string[] = ["inpSearchNear"];
    private static readonly inputPromptElementId: string = "oneSearchTypeaheadPrompt";

    private static showHotelNameSearchSupportedInfo($dropDownElement: JQuery): void {
        let contentLiStyle: string = "padding-top:0.92307692em;" +
            "padding-right:0.92307692em;" +
            "padding-bottom:0;" +
            "padding-left:0.92307692em;" +
            "margin-top:0.92307692em;" +
            "border-top-width:1px;" +
            "border-top-style:solid;" +
            "border-top-color:#DDD;";
        let contentDivStyle: string = "display:block;" +
            "padding-top:0;" +
            "padding-right:0.46153846em;" +
            "padding-bottom:0;" +
            "padding-left:0.46153846em;";

        let contentIconSpanStyle: string = "padding-right:0.76923077em;";
        let contentTextSpanStyle: string = "font-size:0.9em";
        let labelString: string = loc.taOnesearchPromptText ?
            loc.taOnesearchPromptText :
            "You can also search by hotel name or attraction";
        // Add new child node
        let infoLabelHTML = $.parseHTML("" +
            "<li role='presentation' class='' " +
            "style=" + contentLiStyle + ">" +
            "<div id='oneSearchTypeaheadPromptInner' style=" + contentDivStyle + ">" +
            "<span class='icon icon-info' aria-hidden='true' style=" + contentIconSpanStyle + "></span>" +
            "<span class='ta-onesearch-prompt-text' style=" + contentTextSpanStyle + ">" + labelString + "</span>" +
            "</div>" +
            "</li>");
        $dropDownElement.find("ul").append(infoLabelHTML);
        // $(infoLabelHTML).after($dropDownElement.find("ul"));

    }

    private static updateQueryParam(query: string, key: string, value: string): string {
        let urlQueryString: string = query;
        let newParam: string = key + "=" + value;
        let params: string = "?" + newParam;

        // If the "search" string exists, then build params from it
        if (urlQueryString) {

            let updateRegex: RegExp = new RegExp(key + "[^&]*");
            let removeRegex: RegExp = new RegExp(key + "=[^&;]+[&;]?");

            if (typeof value === "undefined" || value === null || value === "") {
                // Remove param if value is empty
                params = urlQueryString.replace(removeRegex, "$1");
                params = params.replace(/[&;]$/, "");
            } else if (urlQueryString.match(updateRegex) !== null) {
                // If param exists already, update it
                params = urlQueryString.replace(updateRegex, "" + newParam);
            } else {
                // Otherwise, add it to end of query string
                params = urlQueryString + "&" + newParam;
            }
        }
        return params;
    }

    private static setOnesearchUIPromptsOnPage($inputElement: JQuery): void {
        $inputElement.attr("placeholder", loc.taOneSearchPlaceholderText);
        // Prompt container is only visible after the input receives focus
        let $promptContainer: JQuery = $("#" + IncludeHotelsNearRegion.inputPromptElementId);
        $($promptContainer).children()
            .find("span.onesearch-prompt-text").text(loc.taOnesearchPromptText);
        $($promptContainer).css("display", "block");
    }

    private latLong: string;
    private regionId: string;
    private selected: string;
    private searchPriorityOverride: string;
    private cityName: string;

    public getExperiments(): Experiment[] {
        return StripingConfiguration.getExperiments(configuration);
    }

    // Check for input element ID as well (Only for change search)
    public modifyParameters(params: ISuggestServiceQueryParams, context: IContext, options?: IInputElementConfig):
        ISuggestServiceQueryParams {
        /* Verify that the experiment is only for HSRP and for Change search input TA*/
        if (IncludeHotelsNearRegion.applicableClientIds.indexOf(TypeaheadUtils.getClientId()) > -1
            && IncludeHotelsNearRegion.applicableTextInputElementIds.indexOf(options.inputElementId) > -1) {
            if (ExecutionHelper.shouldExecute(context, configuration)) {
                params.rid = options.searchRegionId;
                /* tslint:disable-next-line: no-bitwise */
                params.mask |= hotelNameHotelBits;

                // make the call to add parameters
                addFeatureFlag(featureFlag, configuration, params, context);
            }
        }
        return params;
    }

    public handleContentToShow($dropDownElement: JQuery, $inputElement: JQuery, context: IContext): void {
        /* Verify that the experiment is only for HSRP and for Change search input TA*/
        if (IncludeHotelsNearRegion.applicableClientIds.indexOf(TypeaheadUtils.getClientId()) > -1
                && IncludeHotelsNearRegion.applicableTextInputElementIds
                .indexOf($inputElement.attr("id")) > -1
                && ExecutionHelper.shouldExecute(context, configuration)) {
            IncludeHotelsNearRegion.showHotelNameSearchSupportedInfo($dropDownElement);
        }
    }

    public handlePageLoad(options: any, context: IContext): void {
        // NOTE: The listeners are registered at page load but executed when triggered

        TypeaheadMessage.subscribe(
            ElementFocusedMessage.getTopic(),
            (topic: string, message: ElementFocusedMessage) => {
                // Exposure Logging done only when changeSearch input receives focus
                if (ExecutionHelper.shouldExecute(context, configuration)) {
                    // Populate the search prompt under the search input
                    let inputId: string = message.getDomElementId();
                    IncludeHotelsNearRegion.setOnesearchUIPromptsOnPage($("#" + inputId));
                }
            });

        // This is default behavior for uTA on HSR change search
        TypeaheadMessage.subscribe(
            InputValueEditedMessage.getTopic(),
        (topic: string, message: InputValueEditedMessage) => {
                // Reset the regionId, hotelId and latLong param
                this.clearRegionIdForChangeSearchSelection();
                this.clearLatLongForChangeSearchSelection();
                this.clearHotelIdForChangeSearchSelection();
                // Remove the searchOverride
                $("input[name='searchPriorityOverride']").val("");
        });

        TypeaheadMessage.subscribe(
            SuggestionSelectedMessage.getTopic(),
        (topic: string, suggestion: SuggestionSelectedMessage) => {

            let hotelId: string = suggestion.getSuggestion().getHotelId().orElse("");
            let regionId: string = suggestion.getSuggestion().getRegionId().orElse("");
            let latLong: string = suggestion.getSuggestion().getLatLong().orElse("");
            let cityName: string = suggestion.getSuggestion().getCity().orElse("");

            // The following logic only executes if in experiment bucket
            if (ExecutionHelper.shouldExecute(context, configuration)) {
                // This fetches the {field: "searchPriorityOverride", value: "213"} for a hotel suggestion
                let params: Optional<IExtraSearchParam[]> =
                    suggestion.getSuggestion().getExtraSearchParams();
                this.regionId = regionId;
                this.latLong = latLong;

                if (!!hotelId) {
                    params.orElse([]).forEach((param: IExtraSearchParam) => {
                        if (param.field === "searchPriorityOverride") {
                            this.searchPriorityOverride = param.value;
                        }
                    });
                    this.selected = hotelId;
                    this.cityName = cityName;
                }
            } else {
                // Typeahead selection in control
                if (hotelId) {
                    this.selected = hotelId;
                } else {
                    this.clearHotelIdForChangeSearchSelection();
                }
            }
        });

        // The following code is to handle regionID, latLong, selected and searchPriorityOverride
        // params at Change Search submit in the URL
        uitk.subscribe(ClientHandlerRegistry.HSR_SUBMIT_GET_QUERY_MESSAGE,
        (uitktopic: string, submitObject: IHsrpSubmitData) => {

            // Enable regionId, latLong if experiment is ON
            if (ExecutionHelper.shouldExecute(context, configuration)) {
                this.setRegionIdForChangeSearchSelection(submitObject);
                this.setLatLongForChangeSearchSelection(submitObject);

                if (this.selected) {
                    // set selected, regionId, latlong and searchParamOverride
                    this.setSelectedHotelIdForChangeSearchSelection(submitObject);
                } else {
                    // Remove the searchOverride element
                    // to undo the HSR query prexisting previous override
                    $("input[name='searchPriorityOverride']").val("");
                }
            }

        });

        // Update the destination param to the cityName in case of a hotel suggestion selection
        uitk.subscribe(ClientHandlerRegistry.HSR_SUBMIT_BEFORE_UPDATE_HASH_MESSAGE,
        (uitktopic: string, submitObject: IHsrpSubmitData) => {
            if (this.selected) {
                let query: string = IncludeHotelsNearRegion.updateQueryParam(submitObject.query,
                    "destination", this.cityName);
                submitObject.query = query;
            } else {
                // Remove the searchPriorityOverride param only if a hotelID search is not submitted
                if ( !$("#selected").val()) {
                    // Remove the searchOverride element
                    // to undo the HSR query presisting previous override
                    $("input[name='searchPriorityOverride']").val("");
                }
            }
        });
    }

    private setRegionIdForChangeSearchSelection(submitObject: IHsrpSubmitData): void {
        let regionId: string = this.regionId;
        if (regionId) {
            $("#regionId").val(regionId);
            if (submitObject.query && submitObject.query.indexOf("regionId") === -1) {
                submitObject.query += "&regionId=" + regionId;
            }
        }
    }

    private clearRegionIdForChangeSearchSelection(): void {
        this.regionId = null;
        $("#regionId").val("");
    }

    private setSelectedHotelIdForChangeSearchSelection(submitObject: IHsrpSubmitData): void {
        let selected: string = this.selected;
        let searchPriorityOverride: string = this.searchPriorityOverride;
        if (selected) {
            $("#selected").val(selected);
            if (submitObject.query && submitObject.query.indexOf("selected") === -1) {
                submitObject.query += "&selected=" + selected;
            }
            if (submitObject.query && submitObject.query.indexOf("searchPriorityOverride") === -1) {
                submitObject.query += "&searchPriorityOverride=" + searchPriorityOverride;
            }
        }
    }

    private clearHotelIdForChangeSearchSelection(): void {
        this.selected = null;
        $("#selected").val("");
        this.searchPriorityOverride = null;
        $("input[name='searchPriorityOverride']").val("");
        this.cityName = null;
    }

    private setLatLongForChangeSearchSelection(submitObject: IHsrpSubmitData): void {
        let latLong: string = this.latLong;
        if (latLong) {
            $("#latLong").val(latLong);
            if (submitObject.query && submitObject.query.indexOf("latLong") === -1) {
                submitObject.query += "&latLong=" + latLong;
            }
        }
    }

    private clearLatLongForChangeSearchSelection(): void {
        this.latLong = null;
        $("#latLong").val("");
    }

}
